import { MdOutlineLocationOn, MdOutlineEmail } from 'react-icons/md';
import { BiPhoneCall } from 'react-icons/bi';

export const contactInfo = [
  {
    Icon: MdOutlineLocationOn,
    title: 'Our Address',
    text: 'Orangi Town, Pakistan',
  },
  {
    Icon: MdOutlineEmail,
    title: 'Email Us',
    text: 'smjunaid105@gmail.com',
  },
  {
    Icon: BiPhoneCall,
    title: 'Call Us',
    text: '+92 233292381',
  },
];
